import { ApiListResponse } from "@gymflow/types";

export const numberPagination = {
  getNextPageParam: (lastPage: ApiListResponse<any>) =>
    lastPage.last ? undefined : lastPage.number + 1,
  initialPageParam: 0,
} as const;
